import { memo } from 'react';

import { Skeleton, Space } from 'antd';

import styled, { StyledProp, css } from '@/styled';

import { AspectRatioTypes, aspectRatioPadding } from '../ImageRatio';

interface LoadingCardProps extends StyledProp {
  aspect?: AspectRatioTypes;
}

const SkeletonBaseCard = ({ className }: LoadingCardProps) => {
  return (
    <div className={className}>
      <Space direction='vertical' size={8}>
        <Skeleton.Image rootClassName='wrapperSkeletonImage' />
        <Skeleton.Input size='small' rootClassName='wrapperSkeletonInput' />
      </Space>
    </div>
  );
};

export default memo(styled(SkeletonBaseCard)`
  ${({ theme, aspect = '16:9' }) => {
    return css`
      width: 100%;
      display: flex;
      flex-direction: column;

      .wrapperSkeletonImage {
        width: 100%;

        .ant-skeleton-image {
          width: 100%;
          height: 0;
          position: relative;
          padding-top: ${aspectRatioPadding[aspect]};

          svg {
            display: none;
          }
        }
      }

      .wrapperSkeletonInput {
        margin: ${theme.space.spacing(0, 2)};
      }
    `;
  }}
`);
